<template>
    <QToolbar class="Toolbar">
        <QBtn
            flat
            round
            dense
            color="primary"
            icon="arrow_back"
            :aria-label="$t('general.back')"
            :disable="!canGoBack"
            @click="goBack"
        />
        <QBtn
            flat
            round
            dense
            color="primary"
            icon="arrow_forward"
            :aria-label="$t('general.forward')"
            :disable="!canGoForward"
            @click="goForward"
        />
        <QSeparator
            vertical
            inset
            class="q-mx-md"
        />
        <div class="Breadcrumbs">
            <Breadcrumb />
        </div>

        <q-space />

        <div
            v-if="$slots.actions"
            class="flex"
        >
            <slot name="actions" />
        </div>
    </QToolbar>
</template>

<script>
import { Breadcrumb } from '@/components'

export default {
    name: 'AdminHeader',
    components: {
        Breadcrumb,
    },
    data() {
        return {
            historyHasBack: null,
            historyHasForward: null,
        }
    },
    computed: {
        canGoBack() {
            if (this.historyHasBack === null) return true
            return this.historyHasBack
        },
        canGoForward() {
            if (this.historyHasForward === null) return true
            return this.historyHasForward
        },
    },
    watch: {
        '$route.fullPath': {
            handler() {
                this.$nextTick(() => {
                    this.refreshHistoryState()
                })
            },
            immediate: true,
        },
    },
    mounted() {
        this.refreshHistoryState()

        if (typeof window !== 'undefined') {
            window.addEventListener('popstate', this.refreshHistoryState)
        }
    },
    beforeUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('popstate', this.refreshHistoryState)
        }
    },
    methods: {
        refreshHistoryState() {
            if (typeof window === 'undefined') return

            const state = window.history?.state
            if (!state || typeof state !== 'object') {
                this.historyHasBack = null
                this.historyHasForward = null
                return
            }

            if ('back' in state) this.historyHasBack = !!state.back
            else this.historyHasBack = null

            if ('forward' in state) this.historyHasForward = !!state.forward
            else this.historyHasForward = null
        },
        goBack() {
            if (!this.canGoBack) return
            this.$router.go(-1)
        },
        goForward() {
            if (!this.canGoForward) return
            this.$router.go(1)
        },
    },
}
</script>

<style scoped lang="scss">
.Toolbar {
    height: 100%;
}

.HeaderLeft {
    min-width: 0;
}

.HeaderSeparator {
    height: 26px;
}

.Breadcrumbs {
    min-width: 0;
}
</style>
